import React from 'react'
import { useParams } from 'react-router-dom'
import { Box } from '@mui/material'
import { TransformedFaberUserData } from 'types/api/faber/globalCustomers.type'

import ExternalPaymentLogsV2 from './ExternalPaymentLogsV2'

function ExternalFinanceV2OneUser(props: FinanceProfileProps) {
  const { customerRow } = props
  const { id } = useParams()

  return (
    <Box>
      <ExternalPaymentLogsV2
        customerId={id}
        customerRow={customerRow}
        handleRefundRequestTabChange={() => void 0}
      />
    </Box>
  )
}

export default ExternalFinanceV2OneUser

interface FinanceProfileProps {
  customerRow: TransformedFaberUserData
}
